import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth, isSuperAdmin } from '@/hooks/useAuth';
import { isStandalone } from '@/lib/pwa';

/**
 * PwaEntryRedirect — quand l'application est ouverte en mode « installé »
 * (PWA) et que la session est déjà ouverte, on affiche directement le tableau
 * de bord au lieu de la page d'accueil publique.
 *
 * Le comportement reprend exactement les règles de redirection après connexion
 * (superadmin → /superadmin, client → /mon-compte, développeur → /developpeur,
 * sinon → /dashboard). On n'agit QUE sur la page d'accueil « / » pour ne jamais
 * perturber une navigation en cours.
 */
export default function PwaEntryRedirect() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!isStandalone()) return;
    if (!user) return;
    if (location.pathname !== '/') return;

    let target = '/dashboard';
    if (isSuperAdmin(user.typecompte)) target = '/superadmin';
    else if (user.typecompte === 6) target = '/mon-compte';
    else if (user.typecompte === 8) target = '/developpeur';

    navigate(target, { replace: true });
  }, [user, loading, location.pathname, navigate]);

  return null;
}